import { useState } from "react";
import Tabs from "@/components/Usados/Tabs";
import ListarEquipos from "./equiposTab/listar";
import CrearEquipo from "./equiposTab/crear";

export default function EquiposTab() {
  const [activeTab, setActiveTab] = useState("Listar");
  const [equipoParaEditar, setEquipoParaEditar] = useState<any>(null);

  const handleEditar = (equipo: any) => {
    setEquipoParaEditar(equipo);
    setActiveTab("crear");
  };

  const handleFinalizado = () => {
    setEquipoParaEditar(null);
    setActiveTab("Listar");
  };

  const tabs = [
    {
      value: "Listar",
      label: "Lista de equipos",
      content: <ListarEquipos onEdit={handleEditar} />,
    },
    {
      value: "crear",
      label: equipoParaEditar ? "Editar equipo" : "Crear equipo",
      content: (
        <CrearEquipo
          equipo={equipoParaEditar}
          onSuccess={handleFinalizado}
          onCancel={() => {
            setEquipoParaEditar(null);
            setActiveTab("Listar");
          }}
        />
      ),
    },
  ];

  return (
    <div className="space-y-6">
      <Tabs
        tabs={tabs}
        activeTab={activeTab}
        onTabChange={setActiveTab}
        activeTextClass="text-green-800"
        activeBorderClass="border-green-800"
        activeGlowClass="bg-green-800/40"
      />
    </div>
  );
}
